const i18nData = {
  en: {
    k001: 'Turn your free time into daily cash! 💸',
    k002: 'Code:',
    k006: '100% private, flexible hours, and fast payouts. Join thousands of women earning from home.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'copy',
    copied: 'Copied',
    nicknameFallback: '[Nickname]',
  },
  ar: {
    k001: 'حوّلي وقت فراغك إلى دخل يومي! 💸',
    k002: 'الرمز:',
    k006: 'خصوصية 100%، ساعات مرنة، ومدفوعات سريعة. انضمي إلى آلاف النساء اللواتي يكسبن من المنزل.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'نسخ',
    copied: 'منسوخ',
    nicknameFallback: '[الاسم]',
  },
  az: {
    k001: 'Boş vaxtınızı gündəlik pula çevirin! 💸',
    k002: 'Kod:',
    k006: '100% məxfi, çevik saatlar və sürətli ödənişlər. Evdən qazanan minlərlə qadına qoşulun.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'kopyala',
    copied: 'Kopyalandı',
    nicknameFallback: '[Nickname]',
  },
  bn: {
    k001: 'আপনার অবসর সময়কে দৈনিক আয়ে রূপান্তর করুন! 💸',
    k002: 'কোড:',
    k006: '১০০% গোপনীয়, নমনীয় সময় এবং দ্রুত পেমেন্ট। বাড়ি থেকে আয় করা হাজার হাজার নারীর সাথে যোগ দিন।',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'কপি',
    copied: 'কপি হয়েছে',
    nicknameFallback: '[Nickname]',
  },
  da: {
    k001: 'Gør din fritid til daglig indkomst! 💸',
    k002: 'Kode:',
    k006: '100% privat, fleksible timer og hurtige udbetalinger. Slut dig til tusindvis af kvinder, der tjener hjemmefra.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'kopi',
    copied: 'Kopieret',
    nicknameFallback: '[Nickname]',
  },
  de: {
    k001: 'Verwandle deine Freizeit in tägliches Einkommen! 💸',
    k002: 'Code:',
    k006: '100% privat, flexible Zeiten und schnelle Auszahlungen. Schließe dich Tausenden von Frauen an, die von zu Hause verdienen.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'kopieren',
    copied: 'Kopiert',
    nicknameFallback: '[Nickname]',
  },
  es: {
    k001: '¡Convierte tu tiempo libre en dinero diario! 💸',
    k002: 'Código:',
    k006: '100% privado, horarios flexibles y pagos rápidos. Únete a miles de mujeres que ganan desde casa.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'copiar',
    copied: 'Copiado',
    nicknameFallback: '[Nickname]',
  },
  fa: {
    k001: 'وقت آزاد خود را به درآمد روزانه تبدیل کنید! 💸',
    k002: 'کد:',
    k006: '۱۰۰٪ خصوصی، ساعات انعطاف‌پذیر و پرداخت سریع. به هزاران زن که از خانه درآمد دارند بپیوندید.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'کپی',
    copied: 'کپی شد',
    nicknameFallback: '[Nickname]',
  },
  fr: {
    k001: 'Transformez votre temps libre en revenus quotidiens ! 💸',
    k002: 'Code :',
    k006: '100 % privé, horaires flexibles et paiements rapides. Rejoignez des milliers de femmes qui gagnent depuis chez elles.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'copier',
    copied: 'Copié',
    nicknameFallback: '[Nickname]',
  },
  he: {
    k001: 'הפכי את זמן הפנוי שלך להכנסה יומית! 💸',
    k002: 'קוד:',
    k006: '100% פרטי, שעות גמישות ותשלומים מהירים. הצטרפי לאלפי נשים שמרוויחות מהבית.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'העתק',
    copied: 'הועתק',
    nicknameFallback: '[Nickname]',
  },
  id: {
    k001: 'Ubah waktu luangmu jadi penghasilan harian! 💸',
    k002: 'Kode:',
    k006: '100% privat, jam fleksibel, dan pembayaran cepat. Bergabunglah dengan ribuan wanita yang menghasilkan dari rumah.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'salin',
    copied: 'Disalin',
    nicknameFallback: '[Nickname]',
  },
  it: {
    k001: 'Trasforma il tuo tempo libero in guadagno quotidiano! 💸',
    k002: 'Codice:',
    k006: '100% privato, orari flessibili e pagamenti rapidi. Unisciti a migliaia di donne che guadagnano da casa.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'copia',
    copied: 'Copiato',
    nicknameFallback: '[Nickname]',
  },
  ms: {
    k001: 'Tukar masa lapang anda kepada pendapatan harian! 💸',
    k002: 'Kod:',
    k006: '100% peribadi, waktu fleksibel dan pembayaran pantas. Sertai ribuan wanita yang menjana pendapatan dari rumah.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'salin',
    copied: 'Disalin',
    nicknameFallback: '[Nickname]',
  },
  pl: {
    k001: 'Zamień wolny czas w codzienny dochód! 💸',
    k002: 'Kod:',
    k006: '100% prywatnie, elastyczne godziny i szybkie wypłaty. Dołącz do tysięcy kobiet zarabiających w domu.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'kopiuj',
    copied: 'Skopiowano',
    nicknameFallback: '[Nickname]',
  },
  pt: {
    k001: 'Transforme seu tempo livre em dinheiro diário! 💸',
    k002: 'Código:',
    k006: '100% privado, horários flexíveis e pagamentos rápidos. Junte-se a milhares de mulheres que ganham em casa.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'copiar',
    copied: 'Copiado',
    nicknameFallback: '[Nickname]',
  },
  ro: {
    k001: 'Transformă-ți timpul liber în bani zilnici! 💸',
    k002: 'Cod:',
    k006: '100% privat, program flexibil și plăți rapide. Alătură-te miilor de femei care câștigă de acasă.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'copiază',
    copied: 'Copiat',
    nicknameFallback: '[Nickname]',
  },
  ru: {
    k001: 'Превратите свободное время в ежедневный доход! 💸',
    k002: 'Код:',
    k006: '100% конфиденциально, гибкий график и быстрые выплаты. Присоединяйтесь к тысячам женщин, которые зарабатывают дома.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'копировать',
    copied: 'Скопировано',
    nicknameFallback: '[Nickname]',
  },
  th: {
    k001: 'เปลี่ยนเวลาว่างของคุณให้เป็นรายได้รายวัน! 💸',
    k002: 'รหัส:',
    k006: 'ส่วนตัว 100% เวลายืดหยุ่น และจ่ายเงินรวดเร็ว เข้าร่วมกับผู้หญิงหลายพันคนที่หารายได้จากบ้าน',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'คัดลอก',
    copied: 'คัดลอกแล้ว',
    nicknameFallback: '[Nickname]',
  },
  tr: {
    k001: 'Boş zamanını günlük kazanca dönüştür! 💸',
    k002: 'Kod:',
    k006: '%100 gizli, esnek saatler ve hızlı ödemeler. Evden kazanan binlerce kadına katıl.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'kopyala',
    copied: 'Kopyalandı',
    nicknameFallback: '[Nickname]',
  },
  uk: {
    k001: 'Перетворіть вільний час на щоденний дохід! 💸',
    k002: 'Код:',
    k006: '100% конфіденційно, гнучкий графік і швидкі виплати. Приєднуйтесь до тисяч жінок, які заробляють вдома.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'копіювати',
    copied: 'Скопійовано',
    nicknameFallback: '[Nickname]',
  },
  vi: {
    k001: 'Biến thời gian rảnh thành thu nhập hàng ngày! 💸',
    k002: 'Mã:',
    k006: '100% riêng tư, giờ linh hoạt và thanh toán nhanh. Tham gia cùng hàng nghìn phụ nữ kiếm tiền tại nhà.',
    k008: 'Google Play',
    k009: 'App Store',
    k010: 'sao chép',
    copied: 'Đã sao chép',
    nicknameFallback: '[Nickname]',
  },
}

const rtlLangs = { ar: true, fa: true, he: true }

export default {
  data() {
    return {
      t: {},
      isRtl: false,
    }
  },
  created() {
    const query = this.$route.query || {}
    const lang = i18nData[query.lang] ? query.lang : 'en'
    this.t = i18nData[lang]
    this.isRtl = !!rtlLangs[lang]
  },
}
